import { Component, OnInit, Input, OnDestroy,ChangeDetectorRef, HostListener, ViewChild, ElementRef } from "@angular/core";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { WallboardViewService } from "../wallboard-view.service";
import { _stateColors } from "../../../dashboard/modules/current-agent-states/current-agent-states.models";
import { EState } from "../../../../AngularJS/Dashboard/Models/agent-state";
import { WVBase, WVMain } from "../wallboard-view.model";
import { ModuleType } from "../../wallboards.model";

@Component({
    selector: "cv-wallboard-view-current-agent-states-responsive",
    templateUrl: "./wallboard-view-current-agent-states-responsive.component.html",
    styleUrls: ["./wallboard-view-current-agent-states-responsive.component.scss"],
})
export class WallboardViewCurrentAgentStatesResponsiveComponent implements OnInit, OnDestroy
{
    @ViewChild('theadElement') theadElement: ElementRef;
    @Input() firstSlide = false;

    public wvf: WVMain;
    public wvcasf: WVBase;
    public currentAgentStatesData;
    public currentAgentStatesState;
    public localization: Map<string, string>;

    private dataUpdated: boolean = false;
    public contentHeight: number = 0;
    public screenWidth: number;

    private updateTimerRef: NodeJS.Timeout = null;
    private isDestroyed: boolean = false;

    public paddedData = [];

    get hasBackdrop(): boolean {
        return this.wvcasf?.Slide.HasBackdrop ?? false;
    }

    get moduleKey(): string {
        return (this.wvcasf?.Slide.WallboardModuleDetails[0].WallboardModuleKey ?? "" );
    }

    get backgroundID(): number {
        return this.wvcasf?.Slide.BackgroundImageID ?? 0;
    }
    constructor(
        private service: WallboardViewService,
        private cvLocalization: CVLocalizationService,
        private cdr: ChangeDetectorRef
    ) {}

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }

    async ngOnInit(): Promise<void> {
        this.screenWidth = window.innerWidth;

        this.wvf = this.service.WVMain;
        this.wvcasf = this.service.WVAgentStatesResponsive;

        this.wvf.RunSlide = this.firstSlide;
        if (!this.firstSlide) this.wvf.NextSlideReady = false;

        this.localization = await this.cvLocalization.GetSection("Module");

        let moduleState = this.service.loadModuleState(ModuleType.ResponsiveCurrentAgentStates, this.wvf.WallboardCreatorID, this.moduleKey)
            .then((response) => {
                if (this.isDestroyed) return;
                this.currentAgentStatesState = response.currentAgentStatesObj;
            });

        let currentAgentStatesModuleData = this.service.getCurrentAgentStatesResponsiveModuleData(this.wvcasf.Slide.WallboardID,this.moduleKey)
            .then((response) => {
                if (this.isDestroyed) return;
                this.currentAgentStatesData = response;
            });

        Promise.all([moduleState, currentAgentStatesModuleData]).then(
            (responses) => {
                if (this.firstSlide) this.wvf.FirstSlideReady = true;
                else this.wvf.NextSlideReady = true;

                this.runSlide();
            }
        );
    }

    ngOnDestroy(): void {
        //end data updates
        if (this.updateTimerRef != null) {
            clearInterval(this.updateTimerRef);
        }

        this.isDestroyed = true;
    }

    getHeight(element: HTMLElement | null): number {
        return element?.getBoundingClientRect().height || 0;
    }

    getLimitTo = function () {
        let rows = 0;

        let $viewSlide = document.querySelector<HTMLElement>(".wallboardViewSlideContentAreaLight");
        let $header = document.querySelector<HTMLElement>(".wvStaticContent");
        this.contentHeight = this.getHeight($viewSlide) - this.getHeight($header);

        if (this.screenWidth <= 576) {
            const cardTotalHeight = 48 + 10; // 48 height, 10 margin bottom

            rows = (this.contentHeight + 10) / cardTotalHeight;
        } else {
            const rowTotalHeight = 22 + 18; // 22 height, 18 margin bottom
            const theadH = this.theadElement?.nativeElement.offsetHeight || 45;
            rows = (this.contentHeight - theadH + 18) / rowTotalHeight;
        }

        return rows % 1 < 0.75 ? Math.floor(rows) - 1 : Math.floor(rows);
    };

    /**
     * Used to fill the rows/cards
     * @param data Data that is being repeated over
     */
    fillElements(data: any[]): void {
        if (!data || !this.currentAgentStatesData)
            this.paddedData = [];

        let maxDataRows = this.getLimitTo();
        if (isNaN(maxDataRows) || maxDataRows === Infinity) maxDataRows = 10;

        let paddedData = angular.copy(data);

        this.paddedData = paddedData?.slice(0, maxDataRows);
    }

    async runSlide() {
        if (!this.dataUpdated) {
            // Reload the data every 5 secs.
            this.updateTimerRef = setInterval(() => {
                this.updateSlideData();
                this.fillElements(this.currentAgentStatesData?.AllAgentStates);
            }, 5000);

            this.dataUpdated = true;
        }

        if (this.wvf.RunSlide) {
            setTimeout(() => {
                // Was originally this.currentAgentStatesData.length, but that makes no sense because this.currentAgentStatesData is not an array or other collection.
                // This is the closest thing that even approximates something coherent.
                for (let i = 0; i < this.currentAgentStatesData?.OnCall?.length; i++) {
                    this.animateRow(0);
                }
                this.cdr.detectChanges();
            }, 0);
        } else {
            setTimeout(() => {
                this.runSlide();
            }, 1000);
        }
    }

    animateRow(idx) {
        setTimeout(() => {
            $(".wallboardViewSlide[mid=" + this.moduleKey + "]:last").find("#row" + idx).fadeIn(1000);
        }, 500 * idx);
    }

    async updateSlideData() {
        let response: any = await this.service.getCurrentAgentStatesResponsiveModuleData(this.wvcasf.Slide.WallboardID, this.moduleKey);
        this.currentAgentStatesData = response.data;
    }

    getStateColor(state) {
        if (state !== undefined) {
            // Default Colors:
            switch (state) {
                case EState.Available:
                    return _stateColors.green;
                case EState.Inbound:
                    return _stateColors.purple;
                case EState.Outbound:
                    return _stateColors.yellow;
                case EState.Unavailable:
                default: // possibly: Mixed
                    return _stateColors.red;
            }
        }
        return "unset";
    }
}
